'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../styleInject.js');

var css_248z = ".Radio-module_radiogroup__oQVEm:focus{outline:none}";
var styles = {"radiogroup":"Radio-module_radiogroup__oQVEm"};
styleInject["default"](css_248z, '662ea2e2-959b-4093-8a0d-aa49a0602375');

exports["default"] = styles;
